export default __webpack_public_path__ + "static/media/330_dummy2016-restaurant02-de.11a10268.png";